<template>
  <label class="themed-radio">
    <input
      :id="id"
      type="radio"
      :value="value"
      :checked="checked"
      :name="name"
      :disabled="disabled"
      class="themed-radio__input"
      :aria-invalid="ariaInvalid"
      :aria-describedby="ariaDescribedby"
      :aria-required="ariaRequired"
      v-bind="$attrs"
      @change="handleChange"
    />
    <span v-if="label" class="themed-radio__label">{{ label }}</span>
    <slot v-else></slot>
  </label>
</template>

<script>
export default {
  name: 'ThemedRadio',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>
